<template>
  <div class="p-2 flex items-center justify-center">
    <div class="container max-w-screen-lg mx-auto">
      <div>
        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            <div class="text-left mb-2">
              <p class="mb-2 font-medium text-lg text-gray-800">
                {{ props.descriptionTitle }}
              </p>

              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>
            </div>

            <div class="lg:col-span-2">
              <div
                class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
              >
                <!-- nome -->
                <div class="md:col-span-3">
                  <BaseInput
                    v-model="store.name"
                    name="name"
                    :info="'Nome da turma'"
                    label="Nome"
                    :required-field="true"
                    type="text"
                  >
                    <template #append>
                      <CleanInputButton @click="store.name = null" />
                    </template>
                  </BaseInput>

                  <span name="name" class="text-red-600 text-sm" />
                </div>

                <!-- empresa -->
                <div class="md:col-span-2">
                  <label class="flex pl-1 text-xs text-[#2b3038]">
                    Empresa
                  </label>
                  <div class="h-10 flex rounded items-center mt-1">
                    <SimpleSelect
                      class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparen"
                      :initial-value="initialCompanySelected"
                      :data="companyCollect"
                      @selected-data="(val) => (store.company_id = val?.value)"
                    />
                  </div>
                </div>

                <!-- descrição -->
                <div class="md:col-span-5">
                  <BaseInput
                    v-model="store.description"
                    name="info"
                    :info="'Observação'"
                    label="Observação"
                    :required-field="false"
                  >
                    <template #append>
                      <CleanInputButton @click="store.description = null" />
                    </template>
                  </BaseInput>
                </div>

                <!-- fluxo dos alunos -->
                <div class="md:col-span-5 mt-2">
                  <div class="grid gap-4 gap-y-2 text-sm grid-cols-5">
                    <div class="col-span-5">
                      <label
                        class="block mb-2 text-sm font-semibold text-gray-700 text-start"
                        for="form.questionSelected"
                      >
                        Selecionar alunos
                      </label>
                      <div class="h-10 flex rounded items-center">
                        <SimpleSelect
                          class="px-1 py-2 text-center uppercase appearance-none outline-none text-gray-800 w-full bg-transparent"
                          :key="clearOnSelected"
                          :data="studentsCollect"
                          :disable-keyboard="false"
                          @selected-data="(val) => addStudentCollect(val)"
                        />
                      </div>
                      <span
                        name="form.questionSelected"
                        class="text-red-600 text-sm"
                      />
                    </div>
                  </div>
                </div>

                <div
                  :key="studentsSelected?.length"
                  class="md:col-span-5"
                  v-if="studentsSelected?.length"
                >
                  <div class="mt-1 w-full max-h-[20vh] overflow-auto">
                    <h3
                      class="uppercase text-lg font-semibold text-start sticky top-0 bg-white p-1"
                    >
                      Total de alunos: {{ studentsSelected?.length }}
                    </h3>

                    <ul class="flex flex-wrap" v-if="studentsSelected">
                      <li
                        v-for="student in studentsSelected"
                        :key="student.id ?? student.value"
                        class="flex justify-between bg-gray-100 p-2 rounded-md m-1"
                      >
                        <label>
                          <!-- opção -->
                          <label class="font-bold uppercase">
                            {{
                              student.name?.length > 10
                                ? student.name.slice(0, 10).concat("...")
                                : student.name
                            }}
                            <br />
                          </label>
                        </label>

                        <!-- remover -->
                        <button
                          @click="removeStudent(student.id ?? student.value)"
                          class="text-red-500 hover:text-red-700 flex px-1"
                        >
                          <component
                            :is="PhX"
                            class="w-5 h-5 rounded-full bg-white p-0.5"
                          ></component>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- fluxo dos eventos -->
                <div class="md:col-span-5 mt-2">
                  <div class="grid gap-4 gap-y-2 text-sm grid-cols-5">
                    <div class="col-span-5">
                      <label
                        class="block mb-2 text-sm font-semibold text-gray-700 text-start"
                        for="form.questionSelected"
                      >
                        Selecionar treinamentos
                      </label>
                      <div class="h-10 flex rounded items-center">
                        <SimpleSelect
                          class="px-1 py-2 text-center uppercase appearance-none outline-none text-gray-800 w-full bg-transparent"
                          :key="clearOnSelected"
                          :data="eventsCollect"
                          :disable-keyboard="false"
                          @selected-data="(val) => addEventCollect(val)"
                        />
                      </div>
                      <span
                        name="form.questionSelected"
                        class="text-red-600 text-sm"
                      />
                    </div>
                  </div>
                </div>
                <div
                  :key="trainingSelected?.length"
                  class="md:col-span-5"
                  v-if="trainingSelected?.length"
                >
                  <div class="mt-1 w-full max-h-[20vh] overflow-auto">
                    <h3
                      class="uppercase text-lg font-semibold text-start sticky top-0 bg-white p-1"
                    >
                      Treinamentos selecionados: {{ trainingSelected?.length }}
                    </h3>

                    <ul class="flex flex-wrap" v-if="trainingSelected">
                      <li
                        v-for="training in trainingSelected"
                        :key="training.id ?? training.value"
                        class="flex justify-between bg-gray-100 p-2 rounded-md m-1"
                      >
                        <label>
                          <!-- opção -->
                          <label class="font-bold uppercase">
                            {{
                              training.name?.length > 30
                                ? training.name.slice(0, 30).concat("...")
                                : training.name
                            }}
                            <br />
                          </label>
                        </label>

                        <!-- remover -->
                        <button
                          @click="removeTraining(training.id ?? training.value)"
                          class="text-red-500 hover:text-red-700 flex px-1"
                        >
                          <component
                            :is="PhX"
                            class="w-5 h-5 rounded-full bg-white p-0.5"
                          ></component>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="p-2 mt-1 mb-1" />

        <div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import CleanInputButton from "../components/CleanInputButton.vue";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import SimpleSelect from "@/components/Select/SimpleSelect.vue";
import { dataGroups } from "../store/groups";
import { dataFighters } from "../store";
import { mapIdTitleToValueName } from "@/modules/utils/simpleSelect";
import { ref, computed, onBeforeMount } from "vue";
import { showToast as toast } from "@/helpers/UseToasts";
import groupService from "../services/group.service";
import { PhUser, PhUserCircleCheck, PhX } from "@phosphor-icons/vue";
import { dataEvent } from "@/modules/events/store";
import EventService from "@/modules/events/service/event.service";
import collabService from "../services/collab.service";
import { useRoute } from "vue-router";

const group_id = useRoute().params.id;
const props = defineProps({
  descriptionTitle: String,
  create: {
    type: Boolean,
    default: true,
  },
});

const initialCompanySelected = computed(
  () => dataGroups.getters.getInitialCompanySelected
);
const studentsCollect = computed(() =>
  mapIdTitleToValueName(dataFighters.getters.getFighters)
);
const eventsCollect = computed(() =>
  mapIdTitleToValueName(dataEvent.getters?.getAllEvents)
);
const companyCollect = computed(() =>
  mapIdTitleToValueName(dataGroups.getters?.getCompanyCollect)
);
const clearOnSelected = ref(0);
const studentsSelected = computed(() => dataGroups.getters.getStudentsCollect);
const trainingSelected = computed(() => dataGroups.getters.getTrainingsCollect);
const store = dataGroups.state.form;

function addStudentCollect(payload) {
  dataGroups.commit("ADD_STUDENT_COLLECT", payload);
  clearOnSelected.value++;
}

function addEventCollect(payload) {
  dataGroups.commit("ADD_TRAINING_COLLECT", payload);
  clearOnSelected.value++;
}

function removeStudent(cId) {
  if (!cId) return;

  if (store.students) {
    const studentIndex = store.students.findIndex((student) => {
      const studentId = student.id ?? student.value;

      return String(studentId) === String(cId);
    });

    if (studentIndex === -1) {
      return toast("Aviso", "Aluno não encontrado na turma", "error");
    }

    store.students.splice(studentIndex, 1);

    if (props.create !== true) {
      Promise.allSettled([
        groupService
          .removeStudent(group_id, cId)
          .then((res) => {
            if (res?.data?.success) {
              return toast("Sucesso", res?.data?.message, "success");
            }
          })
          .catch((err) => {
            if (
              err?.response?.data?.error &&
              err.response.data.status === 400
            ) {
              return toast("Aviso", err.response.data.message, "error");
            }

            if (
              err?.response?.data?.error &&
              err.response.data.status === 404
            ) {
              return toast("Aviso", err.response.data.message, "error");
            }

            return toast(
              "Aviso",
              "Algo deu errado ao remover aluno da turma",
              "error"
            );
          }),
      ]);
    }
  }
}

function removeTraining(tId) {
  if (!tId) return;

  if (store.trainings) {
    const trainingIndex = store.trainings.findIndex((training) => {
      const trainingId = training.id ?? training.value;

      return String(trainingId) === String(tId);
    });

    if (trainingIndex === -1) {
      return toast("Aviso", "Treinamento não encontrado na turma", "error");
    }

    store.trainings.splice(trainingIndex, 1);

    if (props.create !== true) {
      Promise.allSettled([
        groupService.removeEvent(group_id, tId).catch((err) => {
          if (err?.response?.data?.error && err.response.data.status === 400) {
            return toast("Aviso", err.response.data.message, "error");
          }

          if (err?.response?.data?.error && err.response.data.status === 404) {
            return toast("Aviso", err.response.data.message, "error");
          }

          return toast(
            "Aviso",
            "Algo deu errado ao remover treinamento",
            "error"
          );
        }),
      ]);
    }
  }
}

onBeforeMount(() => {
  if (studentsCollect.value.length == 0) {
    Promise.all([
      getAllEvents(),
      getCustomers(),
      dataGroups.dispatch("getCompanyCollect"),
    ]);
  } else {
    Promise.all([getAllEvents(), dataGroups.dispatch("getCompanyCollect")]);
  }
});

async function getAllEvents() {
  await EventService.getEvents()
    .then((res) => {
      console.log(res.data);
      dataEvent.dispatch("setAllEvents", res.data);
    })
    .catch((err) => {
      toast("Aviso", "Algo deu errado ao buscar eventos", "error");
    });
}

async function getCustomers() {
  await collabService
    .getCustomers()
    .then((res) => {
      dataFighters.dispatch("setFightersCollect", res.data);
    })
    .catch((err) => {
      toast("Erro", "Algo deu errado ao buscar colaboradores", "error");
    });
}
</script>
